import { Fragment } from 'react';

// Component imports
import Field from 'components/Field/Field';
import { InputFinalFormAdapter } from 'components/Input/Input';
import {
  SelectorFinalFormAdapter,
  SELECTOR_TYPES,
} from 'components/Selector/Selector';
// Bootstrap imports
import { Row, Col } from 'forkedlibraries/react-bootstrap';
import Condition from 'formcomponents/Condition/Condition';
import { SPRINKLER_FEATURE_STRINGS } from 'accounts/constants/strings/sprinkler.strings';
import FormLayout from 'layouts/FormLayout/FormLayout';
import PropTypes from 'prop-types';
// Util, Enum and Const imports
import { required } from 'utils/validation';

export function SprinklerFormFields({
  name,
  disabled,
}: {
  name: any;
  disabled?: boolean;
}) {
  return (
    <Fragment>
      <div className="mt-sm">
        <FormLayout.Section
          firstSection
          sectionTitle={SPRINKLER_FEATURE_STRINGS.canResidentsUseIt}
          separatorType="none"
          sectionTitleClassName="text-body"
        >
          <Row>
            <Col md={6}>
              <Field
                fluid
                name={`${name}.attributes.canResidentsUseIt`}
                component={SelectorFinalFormAdapter}
                validate={required}
                type={SELECTOR_TYPES.SMALLTEXTBUTTON}
                buttons={[
                  {
                    label: SPRINKLER_FEATURE_STRINGS.yes,
                    key: true,
                  },
                  {
                    label: SPRINKLER_FEATURE_STRINGS.no,
                    key: false,
                  },
                ]}
              />
            </Col>
          </Row>
          <Condition when={`${name}.attributes.canResidentsUseIt`} is>
            <Row>
              <Col md={12}>
                <Field
                  name={`${name}.attributes.howOperate`}
                  component={InputFinalFormAdapter}
                  validate={required}
                  placeholder={SPRINKLER_FEATURE_STRINGS.inputPlaceholder}
                  disabled={disabled}
                  applyDisabledStyle={disabled}
                />
              </Col>
            </Row>
          </Condition>
        </FormLayout.Section>
      </div>
    </Fragment>
  );
}

SprinklerFormFields.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
};

SprinklerFormFields.defaultProps = {
  name: '',
  disabled: false,
};
